import React from 'react';
import { ButtonTemplateProps } from '..';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import Icon, { IconType } from '../../../icons/Icon';
import { Button, ButtonVariant } from '../Button';

interface DeleteButtonProps extends ButtonTemplateProps {}

export default function DeleteButton(props: DeleteButtonProps) {
  return (
    <Button
      {...props}
      text={props.text || t(TranslationKey.delete).singular.upper}
      leading={<Icon type={IconType.trash1} size={'h-5 w-5'} />}
      variant={ButtonVariant.danger}
    />
  );
}
